/* eslint-disable(prettier/prettier) */
// 🔴 DO NOT EDIT — This file is generated.

import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
const MobileCommunitySvg = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#clip0_593_8179)">
      <mask
        id="mask0_593_8179"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={25}
        height={25}
      >
        <rect x={0.375} y={0.413086} width={24} height={24} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_593_8179)">
        <path
          d="M9.38115 16.3632C9.89615 16.3632 10.3322 16.1826 10.6894 15.8215C11.0464 15.4603 11.2249 15.0221 11.2249 14.507C11.2249 13.992 11.0443 13.5559 10.6832 13.1987C10.322 12.8417 9.88382 12.6632 9.36865 12.6632C8.85365 12.6632 8.41757 12.8438 8.0604 13.205C7.7034 13.5662 7.5249 14.0043 7.5249 14.5195C7.5249 15.0345 7.70549 15.4706 8.06665 15.8277C8.42782 16.1847 8.86599 16.3632 9.38115 16.3632ZM15.3812 16.3632C15.8962 16.3632 16.3322 16.1826 16.6894 15.8215C17.0464 15.4603 17.2249 15.0221 17.2249 14.507C17.2249 13.992 17.0443 13.5559 16.6832 13.1987C16.322 12.8417 15.8838 12.6632 15.3687 12.6632C14.8537 12.6632 14.4176 12.8438 14.0604 13.205C13.7034 13.5662 13.5249 14.0043 13.5249 14.5195C13.5249 15.0345 13.7055 15.4706 14.0667 15.8277C14.4278 16.1847 14.866 16.3632 15.3812 16.3632ZM12.3812 11.2632C12.8962 11.2632 13.3322 11.0826 13.6894 10.7215C14.0464 10.3603 14.2249 9.92215 14.2249 9.40698C14.2249 8.89198 14.0443 8.4559 13.6832 8.09873C13.322 7.74173 12.8838 7.56323 12.3687 7.56323C11.8537 7.56323 11.4176 7.74382 11.0604 8.10498C10.7034 8.46615 10.5249 8.90432 10.5249 9.41948C10.5249 9.93448 10.7055 10.3706 11.0667 10.7277C11.4278 11.0847 11.866 11.2632 12.3812 11.2632ZM12.3834 21.5132C11.1316 21.5132 9.95257 21.2764 8.8464 20.8027C7.74024 20.3291 6.77207 19.6773 5.9419 18.8475C5.11174 18.0176 4.45965 17.0502 3.98565 15.9452C3.51182 14.8404 3.2749 13.6598 3.2749 12.4035C3.2749 11.1471 3.51174 9.97007 3.9854 8.87223C4.45907 7.7744 5.11082 6.8104 5.94065 5.98023C6.77049 5.15007 7.7379 4.49798 8.8429 4.02398C9.94774 3.55015 11.1283 3.31323 12.3847 3.31323C13.641 3.31323 14.8181 3.55007 15.9159 4.02373C17.0137 4.4974 17.9777 5.14915 18.8079 5.97898C19.6381 6.80882 20.2902 7.77423 20.7642 8.87523C21.238 9.9764 21.4749 11.1529 21.4749 12.4047C21.4749 13.6566 21.2381 14.8356 20.7644 15.9417C20.2907 17.0479 19.639 18.0161 18.8092 18.8462C17.9793 19.6764 17.0139 20.3285 15.9129 20.8025C14.8117 21.2763 13.6352 21.5132 12.3834 21.5132ZM12.3749 20.2132C14.5416 20.2132 16.3832 19.4549 17.8999 17.9382C19.4166 16.4216 20.1749 14.5799 20.1749 12.4132C20.1749 10.2466 19.4166 8.4049 17.8999 6.88823C16.3832 5.37157 14.5416 4.61323 12.3749 4.61323C10.2082 4.61323 8.36657 5.37157 6.8499 6.88823C5.33324 8.4049 4.5749 10.2466 4.5749 12.4132C4.5749 14.5799 5.33324 16.4216 6.8499 17.9382C8.36657 19.4549 10.2082 20.2132 12.3749 20.2132Z"
          fill="#F44D2C"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_593_8179">
        <rect
          width={24}
          height={24}
          fill="white"
          transform="translate(0.375 0.413086)"
        />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(MobileCommunitySvg)
export default ForwardRef
